<template>
    <div>
        <Title title="发热人员情况统计">
            <Echarts 
                :options="polar"
                style="width: 100%;height: 100%"
                autoresize
                v-if="ifShowEcharts"/>
        </Title>
    </div>    
</template>
<script>
import miment from 'miment';
import Echarts from "vue-echarts";
// 引入柱状图
require("echarts/lib/chart/bar");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/grid");
require("echarts/lib/component/legendScroll");
require("echarts/lib/component/dataZoom");
import Title from './title'
export default {
    components: { Title,Echarts },
    data(){
        return {
            ifShowEcharts: false,
            polar:  {
                tooltip: {
                    trigger: "axis"
                },
                grid: {
                    left: "0",
                    right: "0",
                    bottom: "15",
                    top: "35",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e",
                        interval: 0,
                        rotate: 30,
                        formatter: function (value, index) {
                                if(value){
                                    let text = value.length > 5 ? value.substring(0,5) + '...' : value;
                                    return text
                                }
                            }
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e"
                    },
                    splitLine: {
                        show: false
                    }
                },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: 0,
                        endValue: 10
                    }
                ],
                series: [
                    {
                        name: "发热人数",
                        type: "bar",
                        prop: "userCount",
                        barWidth: 22,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 5,
                                color: new Echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        { offset: 0, color: "#6147c6" },
                                        { offset: 1, color: "#01cafe" }
                                    ]
                                )
                            }
                        },
                        data: []
                    }
                ]
            }
        }
    },
    props: {
        date: {
            type: String
        }
    },
    methods: {
        // 获取信息
        async getInfo(starttime,endtime){
            let res = await this.$get(this.urlobj.getEpidemicFeverUser,{
                communityId:this.$route.query.communityId || this.$store.state.streetorcommunityid,
                beginTime: starttime,
                endTime: endtime
            })
            this.polar.xAxis.data = res.rows.map(item => item.name);
            this.polar.series[0].data = res.rows.map(item => item.userCount);
            this.ifShowEcharts = true;
        }
    },
    watch: {
        date(newVal){
            let starttime,endtime

            

            if(newVal == '日期选择'){
                this.getInfo();
                return
            }
            if(newVal.length == 6){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4);
                starttime = miment(year + '-' + month + '-' + '01').format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + new Date(year,month,0).getDate()).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }else if(newVal.length == 8){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4,6);
                let date = newVal.substring(6,7);
                starttime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }
        }
    },
    created(){
        this.getInfo();
    }
}
</script>
<style lang="less" scoped>

</style>